import React from 'react'

export default (props) =>
  <svg {...props} width='70' height='173' viewBox='0 0 70 173' fill='none'>
    <path d='M47 33H62C66.4183 33 70 29.4183 70 25V8.00001C70 3.58173 66.4183 5.10709e-06 62 4.72083e-06L8 0C3.58172 -3.86258e-07 1.87245e-06 3.58172 1.48619e-06 8L0 25C-3.86258e-07 29.4183 3.58172 33 8 33H23L35 45L47 33Z' fill='#6C81B4' />
    <line x1='35' y1='172' x2='35' y2='48' stroke='#7B89AC' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' strokeDasharray='1 8' />
  </svg>
